var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaningGibbousMoonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 50,
    viewBox: "0 0 42 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 25C41.9956 33.4465 39.2337 41.6549 34.1435 48.3493C30.3666 49.7948 26.3018 50.3018 22.291 49.8274C18.2802 49.3531 14.4406 47.9113 11.0949 45.6233C7.74921 43.3354 4.99527 40.2681 3.06459 36.6793C1.13391 33.0905 0.0829308 29.0852 0 25C0.0829308 20.9148 1.13391 16.9095 3.06459 13.3207C4.99527 9.73194 7.74921 6.66464 11.0949 4.37667C14.4406 2.0887 18.2802 0.646934 22.291 0.172583C26.3018 -0.301768 30.3666 0.205158 34.1435 1.65074C39.2337 8.34511 41.9956 16.5535 42 25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaningGibbousMoonIcon);
export default __webpack_public_path__ + "static/media/WaningGibbousMoonIcon.cfdfd1af49ea6c52851d58fc44aa4d70.svg";
export { ForwardRef as ReactComponent };